import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../Common/Table/Table";
import {
  reports,
  reportsApproveReset,
  reportsBulkApproveReject,
  ReportsBulkApproveReject,
  reportsRejectReset,
  reportsReset,
  userReports,
  userReportsReset,
} from "./../../actions/reports/reports";
import PageHeader from "./../PageHeader";
// import moment from "moment";
import { Button, message, Modal, Typography } from "antd";
import { useHistory, useLocation } from "react-router";
import AddReport from "./AddReport";
import BaseCurrency from "../Common/BaseCurrency";
import { hasAccess } from "../../utils";
import moment from 'moment';

const { Title, Text } = Typography;

const Reports = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [reportsData, setReportsData] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [filters, setFilters] = React.useState({});
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [isBulkModalVisible, setIsBulkModalVisible] = React.useState(false);
  const [type, setType] = React.useState("");
  const [totalRecords, setTotalRecords] = React.useState(0);
  const reportsResponse = useSelector((state) => state.reports.reports || {});
  const bulkApprove = useSelector((state) => state.reports.bulkApprove || {});
  const userReportsResponse = useSelector(
    (state) => state.reports.userReports || {},
  );
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );
  const [page, setPage] = React.useState(1);

  const addUserReportsResponse = useSelector(
    (state) => state.reports.addUserReports || {},
  );
  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.createNew) {
      setIsModalVisible(true);
    }

    return () => {
      dispatch(reportsReset());
      dispatch(userReportsReset());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (is_admin !== "") {
      if (is_admin) {
        if (location.state?.status) {
          dispatch(reports({ status: location.state?.status }));
          setFilters({
            ...filters,
            status: location.state?.status,
          });
        } else {
          dispatch(reports());
        }
      } else {
        if (location.state?.status) {
          dispatch(userReports({ status: location.state?.status }));
          setFilters({
            ...filters,
            status: location.state?.status,
          });
        } else {
          dispatch(userReports());
        }
      }
    }
    // eslint-disable-next-line
  }, [is_admin]);

  React.useEffect(() => {
    const { data: { status = "" } = {} } = addUserReportsResponse;
    if (status) {
      dispatch(userReports());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserReportsResponse]);

  React.useEffect(() => {
    const { data: { status = "", message: res_message = "" } = {} } =
      bulkApprove;
    if (status) {
      setIsBulkModalVisible(false);
      setSelectedRows([]);
      setSelectedRowKeys([]);
      dispatch(reports({ ...filters }));
      dispatch({
        type: ReportsBulkApproveReject.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkApprove]);

  React.useEffect(() => {
    const {
      data: {
        response: { reports = [] } = {},
        status = false,
        total_records = 0,
      } = {},
    } = reportsResponse;
    if (status) {
      setReportsData([...reports]);
      setTotalRecords(total_records);
      dispatch(reportsReset());
      dispatch(reportsApproveReset());
      dispatch(reportsRejectReset());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsResponse]);

  React.useEffect(() => {
    const {
      data: {
        response: { reports = [] } = {},
        status = false,
        total_records = 0,
      } = {},
    } = userReportsResponse;
    if (status) {
      setReportsData([...reports]);
      setTotalRecords(total_records);
      dispatch(reportsReset());
      dispatch(reportsApproveReset());
      dispatch(reportsRejectReset());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportsResponse]);

  const handleSearch = (value) => {
    is_admin
      ? dispatch(reports({ ...filters, search_key: value }))
      : dispatch(userReports({ ...filters, search_key: value }));
    setFilters({
      ...filters,
      search_key: value,
    });
    setPage(1);
  };

  // const handleModal = (value) => {
  //   // dispatch(reports({ list_search: value }));
  // }

  const handleRowClick = (evt, record) => {
    if (
      evt.target.className?.includes("ant-checkbox-inner") ||
      evt.target.className?.includes("ant-checkbox") ||
      evt.target.className?.includes("ant-checkbox-input")
    ) {
    } else {
      evt.preventDefault();
      if (record) {
        history.push({
          pathname: `/report-details/${record.id}`,
          state: { reportData: record, status: filters.status },
        });
      }
    }
  };

  const handleAddButton = (evt, record) => {
    // handleModal();
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleFilter = (value) => {
    if (location.state?.status) {
      history.replace("/reports");
    }
    if (value === "true") {
      is_admin
        ? dispatch(reports({ status: true }))
        : dispatch(userReports({ status: true }));
    } else {
      is_admin
        ? dispatch(reports({ ...filters, status: value }))
        : dispatch(userReports({ ...filters, status: value }));
      setFilters({
        ...filters,
        status: value,
      });
    }
    setPage(1);
  };

  const renderBulkOption = (type) => {
    return (
      <>
        <Text>Are you sure you want to bulk {type} ?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          disabled={bulkApprove?.loading}
          onClick={() => {
            if (type === "reject") {
              dispatch(
                reportsBulkApproveReject({
                  type: "reject",
                  reports: selectedRows?.map((ele) => ele.id),
                }),
              );
            } else {
              dispatch(
                reportsBulkApproveReject({
                  type: "approve",
                  reports: selectedRows
                    ?.map((ele) => ele.status === "pending_approval" && ele.id)
                    .filter((ele) => ele),
                }),
              );
            }
          }}
        >
          {type}
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => {
            setIsBulkModalVisible(false);
          }}
        >
          Cancel
        </Button>
      </>
    );
  };
  const onChangeCheckBox = (selectedRowKeys, selectedRows) => {
    setSelectedRows(selectedRows);
    setSelectedRowKeys(selectedRowKeys);
  };
  const columns = [
    {
      title: "Report ID",
      dataIndex: "report_number",
      key: "report_number",
      render: (text, record) => (
        <div className={`render_common_style status_${record?.status}`}>
          {text}
        </div>
      ),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "employee_name",
    },
    {
      title: "Report Name",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Start Date",
      dataIndex: "from_date",
      key: "from_date",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY, HH:mm:ss")}</div>,
    },
    {
      title: "End Date",
      dataIndex: "to_date",
      key: "to_date",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY, HH:mm:ss")}</div>,
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY, HH:mm:ss")}</div>,
    },
    {
      title: "Amount",
      dataIndex: "total_amount",
      key: "total_amount",
      render: (text) => (
        <div>
          <BaseCurrency />
          {text}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <div
          className={`status status_${
            is_admin ? record?.current_report_status : text
          }`}
        >
          {is_admin
            ? record?.current_report_status?.replace(/_/g, " ")
            : text?.replace(/_/g, " ")}
        </div>
      ),
      width: 150,
    },
  ];
  return (
    <div className="reports-div">
      <div className="heading-div">
        <PageHeader
          title={`Reports`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Reports: "/reports/",
          }}
        />
      </div>
      {isModalVisible && (
        <Modal
          title={
            <Title level={4}>
              New Report &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className="right-alinged-modal"
        >
          <AddReport handleCancel={handleCancel} />
        </Modal>
      )}
      <Modal
        title={<Title level={4}>Bulk Action</Title>}
        visible={isBulkModalVisible}
        onCancel={() => {
          setIsBulkModalVisible(false);
        }}
        footer={[]}
        className="center-alinged-modal"
      >
        {renderBulkOption(type)}
      </Modal>
      <Table
        rowKey="id"
        rowSelection={{
          type: "checkbox",
          // ...rowSelection,
          onChange: onChangeCheckBox,
          getCheckboxProps: (record) => ({
            disabled:
              !is_admin ||
              record?.current_report_status !== "pending_approval" ||
              !hasAccess("expense_reports", "write"),
            style: {
              display: is_admin ? "flex" : "none",
            },
          }),
          selectedRowKeys: selectedRowKeys,
        }}
        columns={columns}
        data={reportsData}
        isTopFilter={true}
        activeButton={location?.state?.status}
        selectedRows={selectedRows}
        handleRowClick={handleRowClick}
        handleSearch={handleSearch}
        handleAddButton={handleAddButton}
        placeholder={"Search By Report ID,  Name"}
        module="Report"
        handleFilter={handleFilter}
        is_admin={is_admin}
        dotMenu={
          is_admin
            ? ["employee_name", "from_date", "to_date", "report_name"]
            : ["amount", "report_name", "from_date", "to_date"]
        }
        className="tableStyled"
        pagination={{
          total: totalRecords || 0,
          current: page,
          showSizeChanger: false,
          onChange: (pagee) => {
            if (is_admin) dispatch(reports({ page: pagee, ...filters }));
            else dispatch(userReports({ page: pagee, ...filters }));
            setPage(pagee);
          },
        }}
        approveLoading={bulkApprove?.loading}
        approveClick={() => {
          setType("approve");
          setIsBulkModalVisible(true);
        }}
        rejectClick={() => {
          setIsBulkModalVisible(true);
          setType("reject");
        }}
        handleSort={(key) => {
          is_admin
            ? dispatch(reports({ ...filters, sort_key: key }))
            : dispatch(userReports({ ...filters, sort_key: key }));
          setFilters({
            ...filters,
            sort_key: key,
          });
          setPage(1);
        }}
        topFilters={
          is_admin
            ? [
                { label: "All Reports", filter: "" },
                { label: "Pending Approval", filter: "pending_approval" },
                {
                  label: "Pending Reimbursements",
                  filter: "pending_reimbursement",
                },
                { label: "Rejected", filter: "rejected" },
                { label: "Reimbursed", filter: "reimbursed" },
              ]
            : [
                { label: "All Reports", filter: "" },
                { label: "Pending Approval", filter: "pending_approval" },
                {
                  label: "Pending Reimbursements",
                  filter: "pending_reimbursement",
                },
                { label: "Unsubmitted", filter: "unsubmitted" },
                { label: "Rejected", filter: "rejected" },
                { label: "Reimbursed", filter: "reimbursed" },
              ]
        }
        scroll={{ x: 1500 }}
      />
    </div>
  );
};

export default Reports;
